/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BrandPreferenceLineFragment = { __typename: 'PimBrandLineRef', id: string, title: string, deletedAt?: any | null, brand: { __typename: 'PimBrandRef', id: string, title: string }, mainBrandLine?: { __typename: 'PimMainBrandLineRef', id: string, title: string } | null };

export type BrandPreferenceFragment = { __typename: 'PimBrandPreference', scope: Types.PimProductPreferenceScope, createdAt: any, brand: { __typename: 'PimBrandRef', id: string, title: string, deletedAt?: any | null }, productType?: { __typename: 'PimProductPreferenceProductType', productTypeSystemKey: string, productTypeKey: string } | null, brandLines: Array<{ __typename: 'PimBrandLineRef', id: string, title: string, deletedAt?: any | null, brand: { __typename: 'PimBrandRef', id: string, title: string }, mainBrandLine?: { __typename: 'PimMainBrandLineRef', id: string, title: string } | null }> };

export type PreferenceListItem_PimArticlePreferenceItem_Fragment = { __typename: 'PimArticlePreferenceItem', scope: Types.PimProductPreferenceScope, rank: number, beyondRankDepth: boolean, createdAt: any, articleNumberIdentifier: { __typename: 'PimProductPreferenceArticleNumberIdentifier', supplierId: string, articleNumber: string } };

export type PreferenceListItem_PimBrandPreferenceItem_Fragment = { __typename: 'PimBrandPreferenceItem', scope: Types.PimProductPreferenceScope, rank: number, beyondRankDepth: boolean, createdAt: any, brand: { __typename: 'PimBrandRef', id: string, title: string, deletedAt?: any | null }, brandLines: Array<{ __typename: 'PimBrandPreferenceItemLine', rank: number, beyondRankDepth: boolean, brandLine: { __typename: 'PimBrandLineRef', id: string, title: string, deletedAt?: any | null, brand: { __typename: 'PimBrandRef', id: string, title: string }, mainBrandLine?: { __typename: 'PimMainBrandLineRef', id: string, title: string } | null } }> };

export type PreferenceListItemFragment = PreferenceListItem_PimArticlePreferenceItem_Fragment | PreferenceListItem_PimBrandPreferenceItem_Fragment;

export type BrandPreferencesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type BrandPreferencesQuery = { pimBrandPreferences: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PimBrandPreferencesResult', preferences: Array<{ __typename: 'PimBrandPreference', scope: Types.PimProductPreferenceScope, createdAt: any, brand: { __typename: 'PimBrandRef', id: string, title: string, deletedAt?: any | null }, productType?: { __typename: 'PimProductPreferenceProductType', productTypeSystemKey: string, productTypeKey: string } | null, brandLines: Array<{ __typename: 'PimBrandLineRef', id: string, title: string, deletedAt?: any | null, brand: { __typename: 'PimBrandRef', id: string, title: string }, mainBrandLine?: { __typename: 'PimMainBrandLineRef', id: string, title: string } | null }> }> } };

export type PreferenceListQueryVariables = Types.Exact<{
  productType?: Types.InputMaybe<Types.PimProductTypeRefInput>;
  global?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type PreferenceListQuery = { pimPreferences: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PimPreferencesResult', items: Array<{ __typename: 'PimArticlePreferenceItem', scope: Types.PimProductPreferenceScope, rank: number, beyondRankDepth: boolean, createdAt: any, articleNumberIdentifier: { __typename: 'PimProductPreferenceArticleNumberIdentifier', supplierId: string, articleNumber: string } } | { __typename: 'PimBrandPreferenceItem', scope: Types.PimProductPreferenceScope, rank: number, beyondRankDepth: boolean, createdAt: any, brand: { __typename: 'PimBrandRef', id: string, title: string, deletedAt?: any | null }, brandLines: Array<{ __typename: 'PimBrandPreferenceItemLine', rank: number, beyondRankDepth: boolean, brandLine: { __typename: 'PimBrandLineRef', id: string, title: string, deletedAt?: any | null, brand: { __typename: 'PimBrandRef', id: string, title: string }, mainBrandLine?: { __typename: 'PimMainBrandLineRef', id: string, title: string } | null } }> }> } };

export type BrandPreferenceBrandLinesQueryVariables = Types.Exact<{
  brandId: Types.Scalars['ID']['input'];
  limit: Types.Scalars['Int']['input'];
  offset: Types.Scalars['Int']['input'];
}>;


export type BrandPreferenceBrandLinesQuery = { pimSearchBrandLines: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PimSearchBrandLinesResult', totalCount: number, brandLines: Array<{ __typename: 'PimBrandLineRef', id: string, title: string, deletedAt?: any | null, brand: { __typename: 'PimBrandRef', id: string, title: string }, mainBrandLine?: { __typename: 'PimMainBrandLineRef', id: string, title: string } | null }> } };

export type SetBrandPreferenceMutationVariables = Types.Exact<{
  input: Types.PimSetBrandPreferenceInput;
}>;


export type SetBrandPreferenceMutation = { pimSetBrandPreference: { __typename: 'PimBrandPreferenceWriteResult', ok: boolean } };

export type DeleteProductTypeBrandPreferencesMutationVariables = Types.Exact<{
  input: Types.PimProductTypeBrandPreferencesInput;
}>;


export type DeleteProductTypeBrandPreferencesMutation = { pimDeleteProductTypeBrandPreferences: { __typename: 'PimBrandPreferenceWriteResult', ok: boolean } };

export type ReorderBrandPreferencesMutationVariables = Types.Exact<{
  input: Types.PimReorderBrandPreferencesInput;
}>;


export type ReorderBrandPreferencesMutation = { pimReorderBrandPreferences: { __typename: 'PimBrandPreferenceWriteResult', ok: boolean } };

export type ReorderProductPreferencesMutationVariables = Types.Exact<{
  input: Types.PimReorderProductPreferencesInput;
}>;


export type ReorderProductPreferencesMutation = { pimReorderProductPreferences: { __typename: 'PimBrandPreferenceWriteResult', ok: boolean } };

export const BrandPreferenceLineFragmentDoc = gql`
    fragment BrandPreferenceLine on PimBrandLineRef {
  id
  title
  deletedAt
  brand {
    id
    title
  }
  mainBrandLine {
    id
    title
  }
}
    `;
export const BrandPreferenceFragmentDoc = gql`
    fragment BrandPreference on PimBrandPreference {
  scope
  brand {
    id
    title
    deletedAt
  }
  productType {
    productTypeSystemKey
    productTypeKey
  }
  brandLines {
    ...BrandPreferenceLine
  }
  createdAt
}
    ${BrandPreferenceLineFragmentDoc}`;
export const PreferenceListItemFragmentDoc = gql`
    fragment PreferenceListItem on PimPreferenceItem {
  __typename
  ... on PimArticlePreferenceItem {
    scope
    rank
    beyondRankDepth
    articleNumberIdentifier {
      supplierId
      articleNumber
    }
    createdAt
  }
  ... on PimBrandPreferenceItem {
    scope
    rank
    beyondRankDepth
    brand {
      id
      title
      deletedAt
    }
    brandLines {
      brandLine {
        ...BrandPreferenceLine
      }
      rank
      beyondRankDepth
    }
    createdAt
  }
}
    ${BrandPreferenceLineFragmentDoc}`;
export const BrandPreferencesDocument = gql`
    query BrandPreferences {
  pimBrandPreferences {
    ... on PimBrandPreferencesResult {
      preferences {
        ...BrandPreference
      }
    }
  }
}
    ${BrandPreferenceFragmentDoc}`;

/**
 * __useBrandPreferencesQuery__
 *
 * To run a query within a React component, call `useBrandPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBrandPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<BrandPreferencesQuery, BrandPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandPreferencesQuery, BrandPreferencesQueryVariables>(BrandPreferencesDocument, options);
      }
export function useBrandPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandPreferencesQuery, BrandPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandPreferencesQuery, BrandPreferencesQueryVariables>(BrandPreferencesDocument, options);
        }
export function useBrandPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrandPreferencesQuery, BrandPreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandPreferencesQuery, BrandPreferencesQueryVariables>(BrandPreferencesDocument, options);
        }
export type BrandPreferencesQueryHookResult = ReturnType<typeof useBrandPreferencesQuery>;
export type BrandPreferencesLazyQueryHookResult = ReturnType<typeof useBrandPreferencesLazyQuery>;
export type BrandPreferencesSuspenseQueryHookResult = ReturnType<typeof useBrandPreferencesSuspenseQuery>;
export type BrandPreferencesQueryResult = Apollo.QueryResult<BrandPreferencesQuery, BrandPreferencesQueryVariables>;
export const PreferenceListDocument = gql`
    query PreferenceList($productType: PimProductTypeRefInput, $global: Boolean) {
  pimPreferences(productType: $productType, global: $global) {
    ... on PimPreferencesResult {
      items {
        ...PreferenceListItem
      }
    }
  }
}
    ${PreferenceListItemFragmentDoc}`;

/**
 * __usePreferenceListQuery__
 *
 * To run a query within a React component, call `usePreferenceListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreferenceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreferenceListQuery({
 *   variables: {
 *      productType: // value for 'productType'
 *      global: // value for 'global'
 *   },
 * });
 */
export function usePreferenceListQuery(baseOptions?: Apollo.QueryHookOptions<PreferenceListQuery, PreferenceListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreferenceListQuery, PreferenceListQueryVariables>(PreferenceListDocument, options);
      }
export function usePreferenceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreferenceListQuery, PreferenceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreferenceListQuery, PreferenceListQueryVariables>(PreferenceListDocument, options);
        }
export function usePreferenceListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreferenceListQuery, PreferenceListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreferenceListQuery, PreferenceListQueryVariables>(PreferenceListDocument, options);
        }
export type PreferenceListQueryHookResult = ReturnType<typeof usePreferenceListQuery>;
export type PreferenceListLazyQueryHookResult = ReturnType<typeof usePreferenceListLazyQuery>;
export type PreferenceListSuspenseQueryHookResult = ReturnType<typeof usePreferenceListSuspenseQuery>;
export type PreferenceListQueryResult = Apollo.QueryResult<PreferenceListQuery, PreferenceListQueryVariables>;
export const BrandPreferenceBrandLinesDocument = gql`
    query BrandPreferenceBrandLines($brandId: ID!, $limit: Int!, $offset: Int!) {
  pimSearchBrandLines(
    limit: $limit
    offset: $offset
    filter: {brandIds: [$brandId]}
  ) {
    ... on PimSearchBrandLinesResult {
      brandLines {
        ...BrandPreferenceLine
      }
      totalCount
    }
  }
}
    ${BrandPreferenceLineFragmentDoc}`;

/**
 * __useBrandPreferenceBrandLinesQuery__
 *
 * To run a query within a React component, call `useBrandPreferenceBrandLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandPreferenceBrandLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandPreferenceBrandLinesQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useBrandPreferenceBrandLinesQuery(baseOptions: Apollo.QueryHookOptions<BrandPreferenceBrandLinesQuery, BrandPreferenceBrandLinesQueryVariables> & ({ variables: BrandPreferenceBrandLinesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandPreferenceBrandLinesQuery, BrandPreferenceBrandLinesQueryVariables>(BrandPreferenceBrandLinesDocument, options);
      }
export function useBrandPreferenceBrandLinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandPreferenceBrandLinesQuery, BrandPreferenceBrandLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandPreferenceBrandLinesQuery, BrandPreferenceBrandLinesQueryVariables>(BrandPreferenceBrandLinesDocument, options);
        }
export function useBrandPreferenceBrandLinesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrandPreferenceBrandLinesQuery, BrandPreferenceBrandLinesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandPreferenceBrandLinesQuery, BrandPreferenceBrandLinesQueryVariables>(BrandPreferenceBrandLinesDocument, options);
        }
export type BrandPreferenceBrandLinesQueryHookResult = ReturnType<typeof useBrandPreferenceBrandLinesQuery>;
export type BrandPreferenceBrandLinesLazyQueryHookResult = ReturnType<typeof useBrandPreferenceBrandLinesLazyQuery>;
export type BrandPreferenceBrandLinesSuspenseQueryHookResult = ReturnType<typeof useBrandPreferenceBrandLinesSuspenseQuery>;
export type BrandPreferenceBrandLinesQueryResult = Apollo.QueryResult<BrandPreferenceBrandLinesQuery, BrandPreferenceBrandLinesQueryVariables>;
export const SetBrandPreferenceDocument = gql`
    mutation SetBrandPreference($input: PimSetBrandPreferenceInput!) {
  pimSetBrandPreference(input: $input) {
    ok
  }
}
    `;
export type SetBrandPreferenceMutationFn = Apollo.MutationFunction<SetBrandPreferenceMutation, SetBrandPreferenceMutationVariables>;

/**
 * __useSetBrandPreferenceMutation__
 *
 * To run a mutation, you first call `useSetBrandPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBrandPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBrandPreferenceMutation, { data, loading, error }] = useSetBrandPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetBrandPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<SetBrandPreferenceMutation, SetBrandPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetBrandPreferenceMutation, SetBrandPreferenceMutationVariables>(SetBrandPreferenceDocument, options);
      }
export type SetBrandPreferenceMutationHookResult = ReturnType<typeof useSetBrandPreferenceMutation>;
export type SetBrandPreferenceMutationResult = Apollo.MutationResult<SetBrandPreferenceMutation>;
export type SetBrandPreferenceMutationOptions = Apollo.BaseMutationOptions<SetBrandPreferenceMutation, SetBrandPreferenceMutationVariables>;
export const DeleteProductTypeBrandPreferencesDocument = gql`
    mutation DeleteProductTypeBrandPreferences($input: PimProductTypeBrandPreferencesInput!) {
  pimDeleteProductTypeBrandPreferences(input: $input) {
    ok
  }
}
    `;
export type DeleteProductTypeBrandPreferencesMutationFn = Apollo.MutationFunction<DeleteProductTypeBrandPreferencesMutation, DeleteProductTypeBrandPreferencesMutationVariables>;

/**
 * __useDeleteProductTypeBrandPreferencesMutation__
 *
 * To run a mutation, you first call `useDeleteProductTypeBrandPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductTypeBrandPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductTypeBrandPreferencesMutation, { data, loading, error }] = useDeleteProductTypeBrandPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProductTypeBrandPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductTypeBrandPreferencesMutation, DeleteProductTypeBrandPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductTypeBrandPreferencesMutation, DeleteProductTypeBrandPreferencesMutationVariables>(DeleteProductTypeBrandPreferencesDocument, options);
      }
export type DeleteProductTypeBrandPreferencesMutationHookResult = ReturnType<typeof useDeleteProductTypeBrandPreferencesMutation>;
export type DeleteProductTypeBrandPreferencesMutationResult = Apollo.MutationResult<DeleteProductTypeBrandPreferencesMutation>;
export type DeleteProductTypeBrandPreferencesMutationOptions = Apollo.BaseMutationOptions<DeleteProductTypeBrandPreferencesMutation, DeleteProductTypeBrandPreferencesMutationVariables>;
export const ReorderBrandPreferencesDocument = gql`
    mutation ReorderBrandPreferences($input: PimReorderBrandPreferencesInput!) {
  pimReorderBrandPreferences(input: $input) {
    ok
  }
}
    `;
export type ReorderBrandPreferencesMutationFn = Apollo.MutationFunction<ReorderBrandPreferencesMutation, ReorderBrandPreferencesMutationVariables>;

/**
 * __useReorderBrandPreferencesMutation__
 *
 * To run a mutation, you first call `useReorderBrandPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderBrandPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderBrandPreferencesMutation, { data, loading, error }] = useReorderBrandPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderBrandPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<ReorderBrandPreferencesMutation, ReorderBrandPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderBrandPreferencesMutation, ReorderBrandPreferencesMutationVariables>(ReorderBrandPreferencesDocument, options);
      }
export type ReorderBrandPreferencesMutationHookResult = ReturnType<typeof useReorderBrandPreferencesMutation>;
export type ReorderBrandPreferencesMutationResult = Apollo.MutationResult<ReorderBrandPreferencesMutation>;
export type ReorderBrandPreferencesMutationOptions = Apollo.BaseMutationOptions<ReorderBrandPreferencesMutation, ReorderBrandPreferencesMutationVariables>;
export const ReorderProductPreferencesDocument = gql`
    mutation ReorderProductPreferences($input: PimReorderProductPreferencesInput!) {
  pimReorderProductPreferences(input: $input) {
    ok
  }
}
    `;
export type ReorderProductPreferencesMutationFn = Apollo.MutationFunction<ReorderProductPreferencesMutation, ReorderProductPreferencesMutationVariables>;

/**
 * __useReorderProductPreferencesMutation__
 *
 * To run a mutation, you first call `useReorderProductPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderProductPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderProductPreferencesMutation, { data, loading, error }] = useReorderProductPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderProductPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<ReorderProductPreferencesMutation, ReorderProductPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderProductPreferencesMutation, ReorderProductPreferencesMutationVariables>(ReorderProductPreferencesDocument, options);
      }
export type ReorderProductPreferencesMutationHookResult = ReturnType<typeof useReorderProductPreferencesMutation>;
export type ReorderProductPreferencesMutationResult = Apollo.MutationResult<ReorderProductPreferencesMutation>;
export type ReorderProductPreferencesMutationOptions = Apollo.BaseMutationOptions<ReorderProductPreferencesMutation, ReorderProductPreferencesMutationVariables>;